import { render, staticRenderFns } from "./_siteChangeLatestShapshot.vue?vue&type=template&id=35fcfb01"
import script from "./_siteChangeLatestShapshot.vue?vue&type=script&lang=js"
export * from "./_siteChangeLatestShapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports